<template>
    <div class="sticky-top">
        <header class="navbar navbar-expand-md d-print-none bg-white" >
            <div class="container-xl">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <h1 class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
                    <a href="#">
                        <img src="https://djbr.contraloria.gov.py/djb-v2/assets/layout/images/logo_1.png" width="314" height="86" alt="CGR Logo" class="">
                    </a>
                </h1>
            </div>
        </header>

        <header class="navbar-expand-md " style="background-color: #285289;">
            <div class="collapse navbar-collapse" id="navbar-menu">
                <div class="navbar">
                    <div class="container-xl">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <router-link to="/portaldjbr" class="nav-link" style="color: white; cursor:pointer;">Inicio</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/licencia" class="nav-link" style="color: white; cursor:pointer;">Licencia</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/aviso-legal" class="nav-link" style="color: white; cursor:pointer;">Aviso legal</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/acerca-de" class="nav-link" style="color: white; cursor:pointer;">Acerca de</router-link>
                            </li>
                        </ul>
                        <div class="navbar-nav flex-row order-md-last"></div>
                    </div>
                </div>
            </div>
        </header>

    </div>
</template>
<script>
export default {
    name: 'TabHeader',

    methods: {

    }
}
</script>